import { render, staticRenderFns } from "./ProfilePdfUploadBanner.vue?vue&type=template&id=500135ed&scoped=true"
import script from "./ProfilePdfUploadBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfilePdfUploadBanner.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfilePdfUploadBanner.vue?vue&type=style&index=0&id=500135ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500135ed",
  null
  
)

export default component.exports